import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";
import { Page } from "../models/page.model";
import { Comune } from "../models/comune.model";
import { Utils } from "../utils";

@Injectable({
  providedIn: "root",
})
export class ComuneService {
  private readonly baseUrl = `${environment.http.apiRoot}/commons/UAT`;

  private size = 50;

  readonly defaultSort = [{ paramName: "descrComune", sortDirection: "ASC" }];

  constructor(private http: HttpClient) {}

  getComuniList(params: HttpParams): Observable<Page<Comune>> {
    let paramsWithSort = params
      .set('sort', 'denominazione,ASC')
      .append('page', Utils.defaultFirstPage.toString())
      .append('size', this.size.toString());

    return this.http.get<Page<Comune>>(`${this.baseUrl}/comuni`, { params: paramsWithSort });
  }

  getProvinceList(params: HttpParams): Observable<Page<any>> {
    let paramsWithSort = params
      .set('sort', 'denominazione,ASC')
      .append('page', Utils.defaultFirstPage.toString())
      .append('size', this.size.toString());

    return this.http.get<Page<any>>(`${this.baseUrl}/province`, { params: paramsWithSort })
  }
}
